import { render, staticRenderFns } from "./TableLevelChange.vue?vue&type=template&id=27708bfe&scoped=true"
import script from "./TableLevelChange.js?vue&type=script&lang=js&external"
export * from "./TableLevelChange.js?vue&type=script&lang=js&external"
import style0 from "./TableLevelChange.vue?vue&type=style&index=0&id=27708bfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27708bfe",
  null
  
)

export default component.exports